import { APIClient } from "api/api_helper";
import { SESSION_API, VOLUNTEER_API } from "api/url_helper";
import { CurrentUser, GetUserData } from "common/service/CommonService";

const api = new APIClient();

export const volunteerEnrollmentApiService = {

  // -----------------------------
  // DROPDOWN
  // -----------------------------
  getDropdownData: (
    studyid?: number | null,
    searchText?: string | null,
  ) => {
    const user = GetUserData() as CurrentUser;
    const payload = {
      studyid: studyid ?? null,
      searchtext: searchText ?? null,
      status: "A",
   
    };

    return api.create(
      VOLUNTEER_API.VOLUNTEER_ENROLLMENT_API + "Dropdown",
      payload
    );
  },

  // -----------------------------
  // SELECT ALL
  // -----------------------------
  getSelectAllData: (
    studyid?: number | null,
    searchText?: string | null,
    pageNumber?: number | null,
    pageSize?: number | null,
    labelPrintStatus?: string | null,
    idCardPrintStatus?: string | null,
    filtersubjectstatus?:boolean|null
  ) => {
    const payload = {
      studyid: studyid ?? null,
      searchtext: searchText ?? null,
      pagenumber: pageNumber ?? null,
      pagesize: pageSize ?? null,
      label_print_status: labelPrintStatus ?? null,
      idcard_print_status: idCardPrintStatus ?? null,
      filter_subject_status:filtersubjectstatus ?? null,
      status: "A",
    };

    return api.create(
       VOLUNTEER_API.VOLUNTEER_ENROLLMENT_API + "SelectAll", payload
    );
  },

  // -----------------------------
  // SUBJECT SELECT ALL (Session)
  // -----------------------------
  getSubjectSelectAll: (
    studyid?: number | null,
    searchText?: string | null,
    labelPrintStatus?: string | null,
    idCardPrintStatus?: string | null,
    filtersubjectstatus?:boolean|null
  ) => {
    const payload = {
      studyid: studyid ?? null,
      searchtext: searchText ?? null,
      label_print_status: labelPrintStatus ?? null,
      idcard_print_status: idCardPrintStatus ?? null,
      filter_subject_status:filtersubjectstatus ?? null,
    };

    return api.create( SESSION_API.SUBJECT_API + "SelectAll", payload );
  },

  // -----------------------------
  // INSERT
  // -----------------------------
  insertData: (payload_data: {
    volunteerid: number;
    studyid: number;
    subjectno: string | number;
    assignments: [];
    replacesubjectno?: string | number | null;
    replaceremarks?: string | null;
  }) => {
    const user = GetUserData() as CurrentUser;

    const payload = {
      volunteerid: payload_data.volunteerid,
      studyid: payload_data.studyid,
      createdby: user.userid,
      assignments: payload_data.assignments,
      subjectno: payload_data.subjectno,
      replacesubjectno: payload_data.replacesubjectno ?? null,
      replaceremarks: payload_data.replaceremarks ?? null,
    };

    return api.create(
      VOLUNTEER_API.VOLUNTEER_ENROLLMENT_API + "Insert",
      payload
    );
  },

  // -----------------------------
  // UPDATE
  // -----------------------------
  updateData: (payload_data: {
    volunteerid: number;
    volunteerassignmentid: number;
    studyid: number;
    subjectno: string | number;
    assignments: [];
    replacesubjectno?: string | number | null;
    replacereason?: string | null;
  }) => {
    const user = GetUserData() as CurrentUser;

    const payload = {
      volunteerid: payload_data.volunteerid,
      volunteerassignmentid: payload_data.volunteerassignmentid,
      studyid: payload_data.studyid,
      updatedby: user.userid,
      assignments: payload_data.assignments,
      subjectno: payload_data.subjectno,
      replacementsubjectno: payload_data.replacesubjectno ?? null,
      replacementreason: payload_data.replacereason ?? null,
    };

    return api.create(
      VOLUNTEER_API.VOLUNTEER_ENROLLMENT_API + "Update",
      payload
    );
  },

  // -----------------------------
  // DELETE
  // -----------------------------
  deleteData: (payload_data: {
    volunteerid: number | null;
    updatereason: string;
  }) => {
    const user = GetUserData() as CurrentUser;

    const payload = {
      volunteerassignmentid: payload_data.volunteerid,
      updatedby: user.userid,
      updatereason: payload_data.updatereason,
   
    };

    return api.create(
      VOLUNTEER_API.VOLUNTEER_ENROLLMENT_API + "Delete",
      payload
    );
  },

  // -----------------------------
  // LOG INSERT
  // -----------------------------
  loginsert: (payload_data: {
    volunteerassignmentid: number | null;
    studyid: number | null;
  }) => {
    const user = GetUserData() as CurrentUser;
    const payload = {
      
      
      printby: user.userid,
      volunteerassignmentid: payload_data.volunteerassignmentid,
      studyid: payload_data.studyid,
    };

    return api.create(
      VOLUNTEER_API.VOLUNTEER_ENROLLMENT_API + "LogInsert",
      payload
    );
  },

  logbulkinsert:(payload_data: {
    studyid: number | null;
    volunteerassignmentids: number[];
  }) => {
    const user = GetUserData() as CurrentUser;
    const payload = {
      
      
      printby: user.userid,
      studyid: payload_data.studyid,
      volunteerassignmentids: payload_data.volunteerassignmentids,
    };

    return api.create(
      VOLUNTEER_API.VOLUNTEER_ENROLLMENT_API + "LogBulkInsert",
      payload
    );
  },

  getSelectLogData: (
    volunteerassignmentid?: number | null,
    searchText?: string | null,
    pageNumber: number = 1,
    pageSize: number = 10,

  ) => {
    const user = GetUserData() as CurrentUser;
    const payload = {
      // otherid: otherid ?? 0,
      currentpage: pageNumber,
      pagesize: pageSize,
      volunteerassignmentid: volunteerassignmentid ?? null,
      
      
    };

    return api.create(
      VOLUNTEER_API.VOLUNTEER_ENROLLMENT_API + "LogSelect",
      payload
    );
  }
};
